// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-flow {
    /* Custom Variables */
    --xy-theme-selected: var(--joy-palette-primary-500);
    --xy-theme-hover: #C5C5C5;
    --xy-theme-edge-hover: black;
    --xy-theme-color-focus: #E8E8E8;
 
    /* Built-in Variables see https://reactflow.dev/learn/customization/theming */
    --xy-node-border-default: 1px solid #EDEDED;
  
    --xy-node-boxshadow-default: 
      0px 3.54px 4.55px 0px #00000005, 
      0px 3.54px 4.55px 0px #0000000D, 
      0px 0.51px 1.01px 0px #0000001A;
  
    --xy-node-border-radius-default: 4px;
  
    --xy-handle-background-color-default: #ffffff;
    --xy-handle-border-color-default: #AAAAAA;
  
    --xy-edge-label-color-default: #505050;
}
 
.react-flow.dark { 
    --xy-node-boxshadow-default: 
    0px 3.54px 4.55px 0px rgba(255, 255, 255, 0.05), /* light shadow */
    0px 3.54px 4.55px 0px rgba(255, 255, 255, 0.13), /* medium shadow */
    0px 0.51px 1.01px 0px rgba(255, 255, 255, 0.2);  /* smallest shadow */  
    --xy-theme-color-focus: #535353;
}
 
/* Customizing Default Theming */
 
.react-flow__node {
    box-shadow: var(--xy-node-boxshadow-default);
    border-radius: var(--xy-node-border-radius-default);
    background-color: var(--xy-node-background-color-default);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0px;
    font-size: 12px;
    flex-direction: column;
    border: var(--xy-node-border-default);
    color: var(--xy-node-color, var(--xy-node-color-default));
}
 
.react-flow__node.selectable:focus {
    box-shadow: 0px 0px 0px 4px var(--xy-theme-color-focus);
    border-color: #d9d9d9;
}
 
.react-flow__node.selectable:focus:active {
    box-shadow: var(--xy-node-boxshadow-default);
}
 
 
.react-flow__node.selectable:hover, 
.react-flow__node.draggable:hover {
    border-color: var(--xy-theme-hover);
}
 
.react-flow__node.selectable.selected {
    border-color: var(--xy-theme-selected);
    box-shadow: var(--xy-node-boxshadow-default);
}
 
.react-flow__node-group {
    background-color: rgba(207, 182, 255, 0.4);
    border-color: #9E86ED;
}
 
.react-flow__edge.selectable:hover .react-flow__edge-path,
.react-flow__edge.selectable.selected .react-flow__edge-path {
    stroke: var(--xy-theme-edge-hover);
}
 
.react-flow__handle {
    background-color: var(--xy-handle-background-color-default);
}
 
.react-flow__handle.connectionindicator:hover {
    pointer-events: all;
    border-color: var(--xy-theme-edge-hover);
    background-color: white;
}
 
.react-flow__handle.connectionindicator:focus , 
.react-flow__handle.connectingfrom,
.react-flow__handle.connectingto {
    border-color: var(--xy-theme-edge-hover);
}
 
.react-flow__node-resizer {
    border-radius: 0;
    border: none;
}
 
.react-flow__resize-control.handle {
    background-color: #ffffff;
    border-color: #9E86ED;
    border-radius: 0;
    width: 5px;
    height: 5px;
}`, "",{"version":3,"sources":["webpack://./src/pages/CallFlows/components/FlowCanvas/styles/styles.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,mDAAmD;IACnD,yBAAyB;IACzB,4BAA4B;IAC5B,+BAA+B;;IAE/B,6EAA6E;IAC7E,2CAA2C;;IAE3C;;;qCAGiC;;IAEjC,oCAAoC;;IAEpC,6CAA6C;IAC7C,yCAAyC;;IAEzC,sCAAsC;AAC1C;;AAEA;IACI;;;kDAG8C,GAAG,oBAAoB;IACrE,+BAA+B;AACnC;;AAEA,gCAAgC;;AAEhC;IACI,4CAA4C;IAC5C,mDAAmD;IACnD,yDAAyD;IACzD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,qCAAqC;IACrC,yDAAyD;AAC7D;;AAEA;IACI,uDAAuD;IACvD,qBAAqB;AACzB;;AAEA;IACI,4CAA4C;AAChD;;;AAGA;;IAEI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;IACtC,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,2DAA2D;AAC/D;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,uBAAuB;AAC3B;;AAEA;;;IAGI,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;IACV,WAAW;AACf","sourcesContent":[".react-flow {\n    /* Custom Variables */\n    --xy-theme-selected: var(--joy-palette-primary-500);\n    --xy-theme-hover: #C5C5C5;\n    --xy-theme-edge-hover: black;\n    --xy-theme-color-focus: #E8E8E8;\n \n    /* Built-in Variables see https://reactflow.dev/learn/customization/theming */\n    --xy-node-border-default: 1px solid #EDEDED;\n  \n    --xy-node-boxshadow-default: \n      0px 3.54px 4.55px 0px #00000005, \n      0px 3.54px 4.55px 0px #0000000D, \n      0px 0.51px 1.01px 0px #0000001A;\n  \n    --xy-node-border-radius-default: 4px;\n  \n    --xy-handle-background-color-default: #ffffff;\n    --xy-handle-border-color-default: #AAAAAA;\n  \n    --xy-edge-label-color-default: #505050;\n}\n \n.react-flow.dark { \n    --xy-node-boxshadow-default: \n    0px 3.54px 4.55px 0px rgba(255, 255, 255, 0.05), /* light shadow */\n    0px 3.54px 4.55px 0px rgba(255, 255, 255, 0.13), /* medium shadow */\n    0px 0.51px 1.01px 0px rgba(255, 255, 255, 0.2);  /* smallest shadow */  \n    --xy-theme-color-focus: #535353;\n}\n \n/* Customizing Default Theming */\n \n.react-flow__node {\n    box-shadow: var(--xy-node-boxshadow-default);\n    border-radius: var(--xy-node-border-radius-default);\n    background-color: var(--xy-node-background-color-default);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    padding: 0px;\n    font-size: 12px;\n    flex-direction: column;\n    border: var(--xy-node-border-default);\n    color: var(--xy-node-color, var(--xy-node-color-default));\n}\n \n.react-flow__node.selectable:focus {\n    box-shadow: 0px 0px 0px 4px var(--xy-theme-color-focus);\n    border-color: #d9d9d9;\n}\n \n.react-flow__node.selectable:focus:active {\n    box-shadow: var(--xy-node-boxshadow-default);\n}\n \n \n.react-flow__node.selectable:hover, \n.react-flow__node.draggable:hover {\n    border-color: var(--xy-theme-hover);\n}\n \n.react-flow__node.selectable.selected {\n    border-color: var(--xy-theme-selected);\n    box-shadow: var(--xy-node-boxshadow-default);\n}\n \n.react-flow__node-group {\n    background-color: rgba(207, 182, 255, 0.4);\n    border-color: #9E86ED;\n}\n \n.react-flow__edge.selectable:hover .react-flow__edge-path,\n.react-flow__edge.selectable.selected .react-flow__edge-path {\n    stroke: var(--xy-theme-edge-hover);\n}\n \n.react-flow__handle {\n    background-color: var(--xy-handle-background-color-default);\n}\n \n.react-flow__handle.connectionindicator:hover {\n    pointer-events: all;\n    border-color: var(--xy-theme-edge-hover);\n    background-color: white;\n}\n \n.react-flow__handle.connectionindicator:focus , \n.react-flow__handle.connectingfrom,\n.react-flow__handle.connectingto {\n    border-color: var(--xy-theme-edge-hover);\n}\n \n.react-flow__node-resizer {\n    border-radius: 0;\n    border: none;\n}\n \n.react-flow__resize-control.handle {\n    background-color: #ffffff;\n    border-color: #9E86ED;\n    border-radius: 0;\n    width: 5px;\n    height: 5px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
